"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactTransitionGroup = require("react-transition-group");

var _themeUi = require("theme-ui");

var _Tether = _interopRequireDefault(require("../Tether/Tether"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TetherExpander = function TetherExpander(_ref) {
  var visible = _ref.visible,
      _tetherComponent = _ref.tetherComponent,
      sourceAnchorCoord = _ref.sourceAnchorCoord,
      menuOriginX = _ref.menuOriginX,
      menuOriginY = _ref.menuOriginY,
      transitionDuration = _ref.transitionDuration,
      fitInViewport = _ref.fitInViewport,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["visible", "tetherComponent", "sourceAnchorCoord", "menuOriginX", "menuOriginY", "transitionDuration", "fitInViewport", "children"]);

  var transitionStyles = {
    exited: {
      opacity: 0,
      visibility: 'hidden',
      transform: 'scale(0.8)',
      transition: function transition(theme) {
        return "visibility " + transitionDuration + "ms, opacity " + transitionDuration + "ms, transform " + transitionDuration + "ms " + theme.easing.slowToQuick;
      }
    },
    entering: {
      opacity: 0,
      visibility: 'hidden',
      transform: 'scale(0.8)',
      transition: function transition(theme) {
        return "visibility " + transitionDuration + "ms, opacity " + transitionDuration + "ms, transform " + transitionDuration + "ms " + theme.easing.slowToQuick;
      }
    },
    entered: {
      opacity: 1,
      visibility: 'visible',
      transform: 'scale(1)',
      transition: function transition(theme) {
        return "visibility " + transitionDuration + "ms, opacity " + transitionDuration + "ms, transform " + transitionDuration + "ms " + theme.easing.quickToSlow;
      }
    },
    exiting: {
      opacity: 0,
      visibility: 'hidden',
      transform: 'scale(0.8)',
      transition: function transition(theme) {
        return "visibility " + transitionDuration + "ms, opacity " + transitionDuration + "ms, transform " + transitionDuration + "ms " + theme.easing.slowToQuick;
      }
    }
  };
  return (0, _themeUi.jsx)(_Tether["default"], {
    shouldUpdatePosition: visible,
    fitInViewport: fitInViewport,
    sourceAnchorCoord: sourceAnchorCoord,
    tetherAnchorCoord: {
      x: menuOriginX === 'right' ? '100%' : '0',
      y: menuOriginY === 'bottom' ? '100%' : '0'
    },
    tetherComponent: function tetherComponent(_ref2) {
      var flippedX = _ref2.flippedX,
          flippedY = _ref2.flippedY;
      return (0, _themeUi.jsx)(_reactTransitionGroup.Transition, {
        "in": visible,
        timeout: {
          enter: 0,
          exit: transitionDuration
        },
        appear: true,
        mountOnEnter: true,
        unmountOnExit: true
      }, function (state) {
        return (0, _themeUi.jsx)("div", _extends({}, props, {
          sx: _extends({
            transformOrigin: (flippedX ? menuOriginX === 'right' ? 'left' : 'right' : menuOriginX) + " " + (flippedY ? menuOriginY === 'bottom' ? 'top' : 'bottom' : menuOriginY)
          }, transitionStyles[state])
        }), _tetherComponent);
      });
    }
  }, children);
};

TetherExpander.propTypes = {
  visible: _propTypes["default"].bool.isRequired,
  tetherComponent: _propTypes["default"].node.isRequired,
  children: _propTypes["default"].node.isRequired,
  sourceAnchorCoord: _propTypes["default"].shape({
    x: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
    y: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
  }),
  menuOriginX: _propTypes["default"].oneOf(['left', 'right']),
  menuOriginY: _propTypes["default"].oneOf(['top', 'bottom']),
  transitionDuration: _propTypes["default"].number,
  fitInViewport: _propTypes["default"].bool
};
TetherExpander.defaultProps = {
  sourceAnchorCoord: {
    x: '100%',
    y: '100%'
  },
  menuOriginX: 'right',
  menuOriginY: 'top',
  transitionDuration: 250,
  fitInViewport: false
};
var _default = TetherExpander;
exports["default"] = _default;